export const canvasTranslationKeys = {
  WIN: 'WIN',
  HOME: 'HOME',
  PLAY: 'PLAY',
  WILD: 'WILD',
  WILDS: 'WILS',
  WILDS_TEXT: 'WILDS_TEXT',
  WILD_RULES_P1: 'WILD_RULES_P1',
  BALANCE: 'BALANCE',
  LAST_WIN: 'LAST WIN',
  SETTINGS: 'SETTINGS',
  AMOUNT: 'AMOUNT',
  SESSION_INACTIVITY: 'SESSION_INACTIVITY',
  PAYTABLE: 'PAYTABLE',
  WILDS_TITLE: 'WILDS_TITLE',
  LOST_CONNECTION: 'LOST_CONNECTION',
  BONUS_ROUND_POPUP: 'BONUS_ROUND_POPUP',
  PLEASE_WAIT: 'PLEASE_WAIT',
  TOTAL_WIN: 'TOTAL_WIN',
  FREE_SPINS_BONUS_1: 'FREE_SPINS_BONUS_1',
  FREE_SPINS_BONUS_2: 'FREE_SPINS_BONUS_2',
  RECONNECTING: 'RECONNECTING',
  BET_NOT_ACCEPTED: 'BET_NOT_ACCEPTED',
  TWO_DEVICE_ENTRANCE: 'TWO_DEVICE_ENTRANCE',
  OK: 'OK',
  AUTO_PLAY: 'AUTO_PLAY',
  AUTO_SPIN_P1: 'AUTO_SPIN_P1',
  AUTO_SPIN_P2: 'AUTO_SPIN_P2',
  AUTO_SPIN_P3: 'AUTO_SPIN_P3',
  AUTO_SPIN_P4: 'AUTO_SPIN_P4',
  LAST_WINNER: 'LAST_WINNER',
  LARGEST_WINNER: 'LARGEST_WINNER',
  CONGRATULATIONS: 'CONGRATULATIONS',
  CONGRATULATIONS_4: 'CONGRATULATIONS_4',
  FREE_SPINS_BONUS: 'FREE_SPINS_BONUS',
  NUMBER_OF_WINNERS: 'NUMBER_OF_WINNERS',
  WILD_TEXT: 'WILD_TEXT',
  MULTIPLIER: 'MULTIPLIER',
  QUICK_INFO: 'QUICK_INFO',
  TURBO_MODE: 'TURBO_MODE',
  TECHNICAL_ISSUES: 'TECHNICAL_ISSUES',
  TURBO_MODE_P1: 'TURBO_MODE_P1',
  QUICK_BETS: 'QUICK_BETS',
  HOW_TO_PLAY: 'HOW_TO_PLAY',
  JACKPOT_TEXT: 'JACKPOT_TEXT',
  SOUNDS_EFFECTS: 'SOUNDS_EFFECTS',
  GAME_FEATURES: 'GAME_FEATURES',
  AUTO_PLAY_TEXT: 'AUTO_PLAY_TEXT',
  AMBIENCE_SOUND: 'AMBIENCE_SOUND',
  FREE_SPINS_LEFT: 'FREE_SPINS_LEFT',
  MULTIPLIER_TEXT: 'MULTIPLIER_TEXT',
  QUICK_INFO_TEXT: 'QUICK_INFO_TEXT',
  TURBO_MODE_TEXT: 'TURBO_MODE_TEXT',
  HOW_TO_PLAY_TEXT: 'HOW_TO_PLAY_TEXT',
  MAINTENANCE: 'MAINTENANCE',
  INTRODUCTION_TEXT: 'INTRODUCTION_TEXT',
  JACKPOT_CONTRIBUTION: 'JACKPOT_CONTRIBUTION',
  RULES_AND_MALFUNCTIONS: 'RULES_AND_MALFUNCTIONS',
  JACKPOT_CONTRIBUTION_TEXT: 'JACKPOT_CONTRIBUTION_TEXT',
  RULES_AND_MALFUNCTIONS_TEXT: 'RULES_AND_MALFUNCTIONS_TEXT',
  CONNECTIVITY_AND_MALFUNCTION: 'CONNECTIVITY_AND_MALFUNCTION',
  MALFUNCTION: 'MALFUNCTION',
  WINNING_LINES_TEXT: 'WINNING_LINES_TEXT',
  CONNECTIVITY_AND_MALFUNCTION_TEXT: 'CONNECTIVITY_AND_MALFUNCTION_TEXT',
  GAME_RULES: 'GAME_RULES',
  GAME_RULES_GAME_FEATURES: 'GAME_RULES_GAME_FEATURES',
  MAX_WIN: 'MAX_WIN',
  GENERAL_INFORMATION: 'GENERAL_INFORMATION',
  QUICK_INFO_MATRIX_SIZE: 'QUICK_INFO_MATRIX_SIZE',
  QUICK_INFO_PAY_LINE: 'QUICK_INFO_PAY_LINE',
  QUICK_INFO_RTP: 'QUICK_INFO_RTP',
  QUICK_INFO_VOLATILITY: 'QUICK_INFO_VOLATILITY',
  QUICK_INFO_MIN_BET: 'QUICK_INFO_MIN_BET',
  QUICK_INFO_MAX_BET: 'QUICK_INFO_MAX_BET',
  HOW_TO_PLAY_P1: 'HOW_TO_PLAY_P1',
  HOW_TO_PLAY_P2: 'HOW_TO_PLAY_P2',
  QUICK_INFO_MAX_ODD: 'QUICK_INFO_MAX_ODD',
  GAME_INFO_HOW_TO_PLAY: 'GAME_INFO_HOW_TO_PLAY',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  ABOUT_THE_GAME_P1: 'ABOUT_THE_GAME_P1',
  INTRODUCTION: 'INTRODUCTION',
  ABOUT_THE_GAME: 'ABOUT_THE_GAME',
  INVALID_TOKEN: 'INVALID_TOKEN',
  JACKPOT: 'JACKPOT',
  JACKPOT_INTRO: 'JACKPOT_INTRO',
  JACKPOT_P1: 'JACKPOT_P1',
  JACKPOT_P2: 'JACKPOT_P2',
  JACKPOT_P3: 'JACKPOT_P3',
  SYMBOL_PAYOUT: 'SYMBOL_PAYOUT',
  SCATTER: 'SCATTER',
  SYMBOL_PAYOUT_1: 'SYMBOL_PAYOUT_1',
  SYMBOL_PAYOUT_2: 'SYMBOL_PAYOUT_2',
  SYMBOL_PAYOUT_3: 'SYMBOL_PAYOUT_3',
  JACKPOT_P4: 'JACKPOT_P4',
  JACKPOT_P5: 'JACKPOT_P5',
  JACKPOT_P6: 'JACKPOT_P6',
  JACKPOT_P7: 'JACKPOT_P7',
  JACKPOT_P8: 'JACKPOT_P8',
  JACKPOT_P9: 'JACKPOT_P9',
  JACKPOT_P10: 'JACKPOT_P10',
  JACKPOT_P11: 'JACKPOT_P11',
  JACKPOT_P12: 'JACKPOT_P12',
  JACKPOT_P13: 'JACKPOT_P13',
  JACKPOT_P14: 'JACKPOT_P14',
  JACKPOT_P15: 'JACKPOT_P15',
  JACKPOT_P16: 'JACKPOT_P16',
  JACKPOT_P17: 'JACKPOT_P17',
  JACKPOT_P18: 'JACKPOT_P18',
  JACKPOT_P19: 'JACKPOT_P19',
  JACKPOT_P20: 'JACKPOT_P20',
  JACKPOT_P21: 'JACKPOT_P21',
  JACKPOT_P22: 'JACKPOT_P22',
  JACKPOT_P23: 'JACKPOT_P23',
  JACKPOT_P24: 'JACKPOT_P24',
  JACKPOT_P25: 'JACKPOT_P25',
  JACKPOT_SERVICE_UNAVAILABLE: 'JACKPOT_SERVICE_UNAVAILABLE',
  HISTORY: 'HISTORY',
  GAMBLE_AMOUNT: 'GAMBLE_AMOUNT',
  GAMBLE_YOU_WIN: 'GAMBLE_YOU_WIN',
  GAMBLE_ATTEMPTS_LEFT: 'GAMBLE_ATTEMPTS_LEFT',
  EXPIRY: 'EXPIRY',
  GAMBLE_FEATURE: 'GAMBLE_FEATURE',
  GAMBLE_AMOUNT_TEXT: 'GAMBLE_AMOUNT_TEXT',
  GAMBLE_TO_WIN_TEXT: 'GAMBLE_TO_WIN_TEXT',
  GAMBLE_ATTEMPTS_LEFT_TEXT: 'GAMBLE_ATTEMPTS_LEFT_TEXT',
  GAMBLE_ATTEMPTS_FINISHED_TEXT: 'GAMBLE_ATTEMPTS_FINISHED_TEXT',
  HIGH_WIN_SYMBOLS: 'HIGH_WIN_SYMBOLS',
  LOW_WIN_SYMBOLS: 'LOW_WIN_SYMBOLS',
  WINNING_LINES: 'WINNING_LINES',
  WILD_TITLE: 'WILD_TITLE',
  GAMBLE_FEATURE_TITLE: 'GAMBLE_FEATURE_TITLE',
  GAMBLE_FEATURE_TEXT: 'GAMBLE_FEATURE_TEXT',
  GAMBLE_VALIDATIONS_TITLE: 'GAMBLE_VALIDATIONS_TITLE',
  GAMBLE_VALIDATIONS: 'GAMBLE_VALIDATIONS',
  GAMBLE_FEATURE_VALIDATIONS_TEXT: 'GAMBLE_FEATURE_VALIDATIONS_TEXT',
  BOOSTED_JACKPOT: 'BOOSTED_JACKPOT',
  WINNERS_COUNT: 'WINNERS_COUNT',
  DURATION: 'DURATION',
  DAYS: 'DAYS',
  HOURS: 'HOURS',
  MINUTES: 'MINUTES',
  SECONDS: 'SECONDS',
  POP_UP_TEXT: 'POP_UP_TEXT',
  WINNING_COUNT: 'WINNING_COUNT',
  WINNERS_COUNT_LEFT: 'WINNERS_COUNT_LEFT',
  PRIZE_POOL: 'PRIZE_POOL',
  PRIZE_POOL_LEFT: 'PRIZE_POOL_LEFT',
  RULES: 'RULES',
  INTRO_DESCRIPTION_1: 'INTRO_DESCRIPTION_1',
  INTRO_DESCRIPTION_2: 'INTRO_DESCRIPTION_2',
  YOU_HAVE_WON: 'YOU_HAVE_WON',
  RULES_TITLE_1: 'RULES_TITLE_1',
  RULES_DESCRIPTION_2: 'RULES_DESCRIPTION_2',
  RULES_TITLE_2: 'RULES_TITLE_2',
  STATE_1: 'STATE_1',
  STATE_2: 'STATE_2',
  STATE_3: 'STATE_3',
  RULES_DESCRIPTION_3: 'RULES_DESCRIPTION_3',
  RULES_DESCRIPTION_4: 'RULES_DESCRIPTION_4',
  STATES_TITLE: 'STATES_TITLE',
  VALIDATIONS_TITLE: 'VALIDATIONS_TITLE',
  VALIDATIONS_1: 'VALIDATIONS_1',
  VALIDATIONS_2: 'VALIDATIONS_2',
  DAILY_AWARDS_TITLE: 'DAILY_AWARDS_TITLE',
  RTP_GLI: 'RTP_GLI',
  GAME_CONTROLS: 'GAME_CONTROLS',
  GAME_CONTROLS_P1: 'GAME_CONTROLS_P1',
  GAME_CONTROLS_P2: 'GAME_CONTROLS_P2',
  GAME_CONTROLS_P3: 'GAME_CONTROLS_P3',
  GAME_CONTROLS_P4: 'GAME_CONTROLS_P4',
  GAME_CONTROLS_P5: 'GAME_CONTROLS_P5',
  GAME_CONTROLS_P6: 'GAME_CONTROLS_P6',
  GAME_CONTROLS_P7: 'GAME_CONTROLS_P7',
  GAME_CONTROLS_P8: 'GAME_CONTROLS_P8',
  GAME_CONTROLS_P9: 'GAME_CONTROLS_P9',
  GAME_CONTROLS_P10: 'GAME_CONTROLS_P10',
  GAME_CONTROLS_P11: 'GAME_CONTROLS_P11',
  GAME_CONTROLS_P12: 'GAME_CONTROLS_P12',
  GAME_CONTROLS_P13: 'GAME_CONTROLS_P13',
  GAMBLE_CONTROLS: 'GAMBLE_CONTROLS',
  GAMBLE_CONTROLS_P1: 'GAMBLE_CONTROLS_P1',
  GAMBLE_CONTROLS_P2: 'GAMBLE_CONTROLS_P2',
  GAMBLE_CONTROLS_P3: 'GAMBLE_CONTROLS_P3',
  GAMBLE_CONTROLS_P4: 'GAMBLE_CONTROLS_P4',
  DEMO_MODE: 'DEMO_MODE',
  LINE: 'LINE',
};
